export const adminUserKeys = {
  all: ['admin-users'] as const,
  lists: () => [...adminUserKeys.all, 'list'] as const,
  list: (params: any) => [...adminUserKeys.lists(), params] as const,
};
